module.exports = __webpack_public_path__ + "img/nike-white.dcebfcc7.jpg";